module.exports = __webpack_public_path__ + "Storyboard1.png?3007f8abf8dc77b02ad3d41afeb3ec4d";


//////////////////
// WEBPACK FOOTER
// ./static/Storyboard1.png
// module id = 345
// module chunks = 0